import React, { createContext, useReducer } from "react";
import { makeUserManager } from "react-oidc";
import { User, UserManagerSettings, UserManager } from "oidc-client"
import { UserActionType, userReducer } from './userReducer'

export type UserContextStateType = {
    userManager: UserManager;
    user: User | null;
    isLoading: boolean;
    shouldSignin: boolean;
    hasAdministratorRole: boolean;
    hasUserRole: boolean;
    hasViewerRole: boolean;
};

const UserManagerConfigInitial: UserManagerSettings = {
    client_id: 'prequest-spa',
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/callback`,
    response_type: 'token id_token',
    scope: 'openid profile prequestapi',
    authority: `${window.location.protocol}//${window.location.hostname}${window.location.port}` + '/identityaccess.webapi',
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/silent_renew`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/logout`,
    automaticSilentRenew: true,
    filterProtocolClaims: false,
    loadUserInfo: true,
};

const initialState: UserContextStateType = {
    userManager: makeUserManager(UserManagerConfigInitial),
    user: null,
    isLoading: true,
    shouldSignin: true,
    hasAdministratorRole: false,
    hasUserRole: false,
    hasViewerRole: false,
};

type UserContextType = {
    state: UserContextStateType,
    dispatch: React.Dispatch<UserActionType>,
}

const UserContext = createContext<UserContextType>({
    state: initialState,
    dispatch: () => null,
});

type UserProviderProps = {
    config: Partial<UserManagerSettings>
}

const UserProvider = ({ children, config }: React.PropsWithChildren<UserProviderProps>) => {
    const newUserManagerConfig = { ...UserManagerConfigInitial, ...config }
    const userManager = makeUserManager(newUserManagerConfig)
    const [state, dispatch] = useReducer(userReducer, { ...initialState, userManager });
    return (
        <UserContext.Provider value={{ state, dispatch }}>
            {children}
        </UserContext.Provider>
    );
};

export { UserContext, UserProvider }
export default UserProvider